export const PORTAL_IDENTITY = 6;
